
import { useState } from 'react';
import { Card } from '@/components/ui/card';
import { TeacherSubject, useTeacherSubjects } from '@/hooks/useTeacherSubjects';
import { SubjectFormDialog } from './components/SubjectFormDialog';
import { SubjectsTable } from './components/SubjectsTable';

interface TeacherSubjectsManagerProps {
  teacherCode: string;
}

export function TeacherSubjectsManager({ teacherCode }: TeacherSubjectsManagerProps) {
  const { subjects, isLoading, addSubject, updateSubject, deleteSubject } = useTeacherSubjects(teacherCode);
  const [editingSubject, setEditingSubject] = useState<TeacherSubject | null>(null);

  const handleSubmit = async (formData: any) => {
    if (editingSubject) {
      return await updateSubject(editingSubject.id, formData);
    } else {
      return await addSubject(formData);
    }
  };

  const handleEdit = (subject: TeacherSubject) => {
    setEditingSubject(subject);
  };

  const handleDelete = async (id: string) => {
    await deleteSubject(id);
  };

  if (isLoading) {
    return <div>กำลังโหลดข้อมูลวิชาที่สอน...</div>;
  }

  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">วิชาที่สอน</h3>
        <SubjectFormDialog
          teacherCode={teacherCode}
          editingSubject={editingSubject}
          onSubmit={handleSubmit}
          onEditingChange={setEditingSubject}
        />
      </div>

      <SubjectsTable
        subjects={subjects}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </Card>
  );
}
